module.exports = __webpack_public_path__ + "static/media/acto_de_grado_2.faf13b15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/acto_de_grado_2.jpg
// module id = 909
// module chunks = 0